@if (localization.isReady()) {
  <router-outlet></router-outlet>
}
